// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"SearchInput_inputGroup__2cIxh","small":"SearchInput_small__2GCGh","icon":"SearchInput_icon__2UeaF","searchInput":"SearchInput_searchInput__3DFxC"};